import React from 'react';
import { FormattedMessage } from 'react-intl';

export enum UserStateName {
    USER_ANY_STATE = 'user_any_state',
    USER_CREATED = 'user_created',
    USER_ACTIVATED = 'user_activated',
    USER_VERIFIED = 'user_verified',
    USER_BLOCKED = 'user_blocked'
}

export class UserState {
    static readonly USER_ANY_STATE = new UserState(
        UserStateName.USER_ANY_STATE,
        (
            <FormattedMessage
                id='UserState.user_any_state'
                description='The displayed value for the UserState user_any_state'
                defaultMessage='Any state'
            />
        )
    );

    static readonly USER_CREATED = new UserState(
        UserStateName.USER_CREATED,
        (
            <FormattedMessage
                id='UserState.user_created'
                description='The displayed value for the UserState user_created'
                defaultMessage='User created'
            />
        )
    );

    static readonly USER_ACTIVATED = new UserState(
        UserStateName.USER_ACTIVATED,
        (
            <FormattedMessage
                id='UserState.user_activated'
                description='The displayed value for the UserState user_activated'
                defaultMessage='User activated'
            />
        )
    );

    static readonly USER_VERIFIED = new UserState(
        UserStateName.USER_VERIFIED,
        (
            <FormattedMessage
                id='UserState.user_verified'
                description='The displayed value for the UserState user_verified'
                defaultMessage='User verified'
            />
        )
    );

    static readonly USER_BLOCKED = new UserState(
        UserStateName.USER_BLOCKED,
        (
            <FormattedMessage
                id='UserState.user_blocked'
                description='The displayed value for the UserState user_blocked'
                defaultMessage='User blocked'
            />
        )
    );

    static readonly ALL = [UserState.USER_ANY_STATE, UserState.USER_CREATED, UserState.USER_ACTIVATED, UserState.USER_VERIFIED, UserState.USER_BLOCKED];

    private constructor(
        public readonly value: UserStateName,
        public readonly displayName: React.ReactNode
    ) {}

    static getByValue(state: UserStateName): UserState | undefined {
        return this.ALL.find((s) => s.value === state);
    }

    static getType(state: UserStateName): string {
        switch (state) {
            case UserStateName.USER_ACTIVATED:
            case UserStateName.USER_VERIFIED:
                return 'bg-status-success';
            case UserStateName.USER_BLOCKED:
                return 'bg-status-danger';
            case UserStateName.USER_CREATED:
                return 'bg-status-info';
            default:
                return 'bg-status-danger';
        }
    }
}
